<p-steps [model]="steps$ | async" [activeIndex]="orderService.addItemStep$ | async" [readonly]="true"></p-steps>

<z-step-0 *ngIf="(orderService.addItemStep$ | async) === 0"></z-step-0>

<z-step-1 *ngIf="(orderService.addItemStep$ | async) === 1"></z-step-1>

<z-step-2 *ngIf="(orderService.addItemStep$ | async) === 2 && (authService.hasPassThru$ | async) === 'Y'"></z-step-2>
